// jQuery(document).ready(function () {
//   var maxLength = 250;
//   jQuery('.show-read-more').each(function () {
//     var myStr = jQuery(this).text();
//     if (jQuery.trim(myStr).length > maxLength) {
//       var newStr = myStr.substring(0, maxLength);
//       var removedStr = myStr.substring(maxLength, jQuery.trim(myStr).length);
//       jQuery(this).empty().html(newStr);
//       jQuery(this).append(
//         ' <a href="javascript:void(0);" class="read-more">read more...</a>'
//       );
//       jQuery(this).append('<span class="more-text">' + removedStr + '</span>');
//     }
//   });
//   jQuery('.read-more').click(function () {
//     jQuery(this).siblings('.more-text').contents().unwrap();
//     jQuery(this).remove();
//   });
// });

document.addEventListener('DOMContentLoaded', function () {
  const iframes = document.querySelectorAll('iframe');
  iframes.forEach((iframe) => {
    layoutIframe(iframe);
  });
});

window.addEventListener('resize', function () {
  const iframes = document.querySelectorAll('iframe');
  iframes.forEach((iframe) => {
    layoutIframe(iframe);
  });
});

function layoutIframe(iframe) {
  var iframeWidth = iframe.clientWidth;
  var iframeHeight = iframeWidth * 0.5625;
  iframe.height = iframeHeight;
}

// Run when page is ready.
window.addEventListener('load', () => {
  // Specify the allowed origin. Adjust this to your site domain (must be prefixed with https://).
  const allowedOrigin = 'https://myleicester.le.ac.uk';
  // Keep track of our HTML element.
  const htmlElement = document.querySelector('html');
  // Selector for our iframe.
  const iframeSelector = '#contact-form';
  // Keep track of our iframe element.
  const iframeElement = document.querySelector(iframeSelector);
  // The position on the page to scroll to (in this case, the top of the iframe minus a few pixels for padding).
  // Adjust this to be suitable for your page.
  const scrollTop = iframeElement.getBoundingClientRect().top - 5;
  /*
   */
  // Options for the iframe resizer.
  const resizerOptions = {
    // Azorus strongly recommends taggedElement as the height calculation method.
    heightCalculationMethod: 'taggedElement',
    checkOrigin: [allowedOrigin],
  };
  // Initialize iFrameResizer on our iframe.
  iFrameResize(resizerOptions, iframeSelector);
  // Whenever the iframe url changes (form submit, etc.), scroll the page to the top of it.
  iframeElement.addEventListener(
    'load',
    () => (htmlElement.scrollTop = scrollTop)
  );
  // iFrame parent listener, which scrolls the page if the form fails to submit (due to javascript-based validation)
  window.addEventListener('message', (msg) => {
    // If the origin is valid, and the message indicates one of:
    // 1. The Form failed to submit due to validation errors
    // 2. The Form did not submit, because a Recaptcha challenge is now visible
    if (
      msg.origin === allowedOrigin &&
      (msg.data === 'AzFormValidationFailed' ||
        msg.data === 'AzFormRecaptchaChallengeVisible')
    ) {
      // Scroll our page to the desired position.
      htmlElement.scrollTop = scrollTop;
    }
  });
});
